<template>
    <div>
        <div :id="editorid"></div>
    </div>
</template>

<script>
/**
 * @file 富文本编辑器，使用 tinymce 实现
 * @author jiaojian04
 */

import tinymce from 'tinymce/tinymce';

// tinymce语言包
import 'tinymce-i18n/langs/zh_CN';

// tinymce皮肤
import 'tinymce/themes/modern/theme';

// tinymce插件
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/lists';
import './plugins/forumImgUpload';
import 'tinymce/plugins/link';

// tinymce皮肤
import 'tinymce/skins/lightgray/skin.min.css';
import 'tinymce/skins/lightgray/content.min.css';

import editorOptions from './utils/editorOptions';

import 'prismjs/prism.js';
import 'prismjs/themes/prism.css';

const canonicalUri = (src, basePath = 'https://smartprogram.baidu.com/') => {
    let rootPage = /^[^?#]*\//.exec(location.href)[0];
    let rootDomain = /^\w+\:\/\/\/?[^\/]+/.exec(rootPage)[0];
    let absoluteRegex = /^\w+\:\/\//;

    // is `src` is protocol-relative (begins with // or ///), prepend protocol
    if (/^\/\/\/?/.test(src)) {
        src = location.protocol + src;
    }
    // is `src` page-relative? (not an absolute URL, and not a domain-relative path, beginning with /)
    else if (!absoluteRegex.test(src) && src.charAt(0) !== '/') {
        // prepend `base_path`, if any
        src = (basePath || '') + src;
    }

    // make sure to return `src` as absolute
    return absoluteRegex.test(src) ? src : ((src.charAt(0) === '/' ? rootDomain : rootPage) + src);
};

export default {
    props: {
        editorid: {
            'type': String,
            'default': ''
        },
        placeholder: {
            'type': String,
            'default': ''
        },
        existcontent: {
            'type': String,
            'default': ''
        }
    },
    mounted() {
        let that = this;
        tinymce.init({
            selector: `#${that.editorid}`,
            ...editorOptions,
            init_instance_callback: editor => {
                if (that.existcontent.length) {
                    that.setContent(that.existcontent);
                }
                editor.on('Change', () => this.$emit('change'));
            }
        });
    },
    destroyed() {
        tinymce.get(this.editorid).remove();
    },
    methods: {
        getContent() {
            let content = tinymce.get(this.editorid).getContent();
            // 匹配所有带有href的a标签
            let regHtmla = /<a[^>]*href=['"]([^"]*)['"][^>]*>(.*?)<\/a>/g;
            // 匹配href
            let regHref = /href=\"(.+?)\"/g;
            if (regHtmla.test(content)) {
                content = content.replace(regHtmla, aHtml => {
                    return aHtml.replace(regHref, hrefUrl => 'href="'
                        + canonicalUri(hrefUrl.slice(6, hrefUrl.length - 1)) + '"');
                });
            }
            // 此处不可去掉换行符等特殊字符
            // 会影响链接与代码片段
            return content;
        },
        getText() {
            return tinymce.get(this.editorid).getContent({format: 'text'}).replace(/[\r\n\s]/g, '');
        },
        setContent(content) {
            tinymce.get(this.editorid) && tinymce.get(this.editorid).setContent(content);
        },
        setPlaceholder(editor, placeholder) {
            this.setContent(placeholder);

            tinymce.get(this.editorid).once('focus', function () {
                this.setContent('');
            });
        }
    }
};
</script>

<style lang="less">
    @import '../../../assets/less/variables.less';
    /* 修改编辑器样式 */
    .mce-container {
        border-color: #cfcfcf;
        box-shadow: none;
        background: #f1f1f1;
    }
    .mce-container-body {
        background: #f1f1f1;
    }
    .mce-btn-group .mce-btn {
        background: #f1f1f1;
    }
    .mce-top-part :before {
        box-shadow: none;
    }
    .mce-menubtn.mce-fixed-width span {
        width: 36px;
    }

    /* 修改link弹窗 */
    .mce-window-body .mce-container-body .mce-formitem .mce-combobox {
        left: 0!important;
    }

    .mce-window-body .mce-container-body .mce-formitem label,
    .mce-window-body .mce-container-body .mce-formitem input:not(:first-child) {
        display: none;
    }
    .mce-window-body .mce-container-body .mce-formitem .mce-combobox::before {
        content: '地址';
        display: inline-block;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
    }
</style>
